import React from 'react';
import { FileText, Plus } from 'lucide-react';

const DocumentManagement: React.FC = () => {
  return (
    <div className="h-full flex flex-col bg-gray-50 dark:bg-gray-950">
      {/* Header */}
      <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-10">
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="bg-brandColor p-2 rounded-lg">
                <FileText className="h-5 w-5 text-white" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Documents</h2>
                <p className="text-xs text-gray-500 dark:text-gray-400">Upload class and student documents</p>
              </div>
            </div>
            <button className="bg-brandColor text-white px-4 py-2 rounded-lg hover:bg-brandColor/90 transition-colors flex items-center gap-2">
              <Plus className="h-4 w-4" />
              Upload Document
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="p-6">
          <div className="max-w-7xl mx-auto">
            <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 p-12 text-center">
              <FileText className="h-12 w-12 text-gray-300 dark:text-gray-600 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Coming Soon</h3>
              <p className="text-gray-600 dark:text-gray-400">
                Document management interface is under development. Stay tuned!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentManagement;
